import { render, staticRenderFns } from "./roleUserTable.vue?vue&type=template&id=5373a1bf&"
import script from "./roleUserTable.vue?vue&type=script&lang=js&"
export * from "./roleUserTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports